import React from "react";
import { AlertTriangle } from "lucide-react";

interface WarningNoticeProps {
  message: string;
  className?: string;
}

const WarningNotice: React.FC<WarningNoticeProps> = ({ 
  message, 
  className = "" 
}) => {
  return (
    <div className={`p-3 bg-yellow-50 dark:bg-yellow-950/20 rounded-md border border-yellow-500/50 ${className}`}>
      <div className="flex items-start space-x-2">
        <AlertTriangle className="h-4 w-4 text-yellow-600 mt-0.5 flex-shrink-0" />
        <p className="text-sm text-yellow-600">
          {message}
        </p>
      </div>
    </div>
  );
};

export default WarningNotice;

